// Keeps bottom sheets sitting on the bottom edge, and above the keyboard while
// typing.
//
// The overlay itself always covers the whole screen (see theme.css). The only
// thing that changes is --kb-inset: how much of the screen the keyboard hides.
// Sizing the overlay to the visible viewport instead used to leave the sheet
// floating mid-screen whenever that measurement was stale, e.g. after the
// keyboard closed or while iOS rubber-band scrolls.

const root = document.documentElement;

let keyboardLikelyOpen = false;

const applyKeyboardInset = () => {
  const vv = window.visualViewport;
  let inset = 0;

  if (keyboardLikelyOpen && vv) {
    // space between the bottom of what is visible and the bottom of the window
    inset = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    // ignore obviously bogus values (rubber-band scrolling reports small ones)
    if (inset < 120) inset = 0;
  }

  root.style.setProperty("--kb-inset", `${inset}px`);
};

const isSheetField = (el) =>
  !!el && typeof el.closest === "function" && /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) && !!el.closest(".bottom-sheet-content");

// Lock the page behind the sheet so it cannot scroll under it.
const syncSheetOpenClass = () => {
  const isOpen = !!document.querySelector(".bottom-sheet-overlay");
  document.body.classList.toggle("sheet-open", isOpen);
  if (!isOpen && keyboardLikelyOpen) {
    keyboardLikelyOpen = false;
    applyKeyboardInset();
  }
};

export const initSheetViewport = () => {
  applyKeyboardInset();
  syncSheetOpenClass();

  document.addEventListener("focusin", (e) => {
    if (isSheetField(e.target)) {
      keyboardLikelyOpen = true;
      applyKeyboardInset();
      // the keyboard animates in, so measure again once it has settled
      setTimeout(applyKeyboardInset, 150);
      setTimeout(applyKeyboardInset, 400);
    }
  });

  document.addEventListener("focusout", () => {
    setTimeout(() => {
      if (!isSheetField(document.activeElement)) {
        keyboardLikelyOpen = false;
        applyKeyboardInset();
      }
    }, 100);
  });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", applyKeyboardInset);
  }
  window.addEventListener("orientationchange", () => setTimeout(applyKeyboardInset, 250));

  if (typeof MutationObserver !== "undefined") {
    new MutationObserver(syncSheetOpenClass).observe(document.body, { childList: true, subtree: true });
  }
};

export default initSheetViewport;
